module.exports = __webpack_public_path__ + "static/media/14.89818951.jpg";